var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors && _vm.errors.length)?_c('span',[_c('ul',_vm._l((_vm.errors),function(error){return _c('li',{key:error.fila,staticClass:"argon-error"},[_vm._v(" Fila "+_vm._s(error.fila)+": "+_vm._s(error.error)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }